import { render, staticRenderFns } from "./closeIcon.vue?vue&type=template&id=4e4f3e53"
import script from "./closeIcon.vue?vue&type=script&lang=js"
export * from "./closeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports